class FP_Login_Box {
	constructor() {
		this.elementWrapper = '.dropdown-wrapper-ui.login';
		this.element = '.header-login-box';
		this.loginBox = document.querySelector(this.element);

		if (!this.loginBox) {
			return;
		}
		
		this.initEvents();
	}

	initEvents() {
		document.addEventListener('mouseover', function(e) {
			this.stickyLoginDropdown(e);
		}.bind(this));

		document.addEventListener('click', function(e) {
			this.closeLoginDropdown(e);
		}.bind(this));
	}

	stickyLoginDropdown(e) {
		let box = e.target.closest(this.elementWrapper);
		if (!box) {
			return;
		}

		box.querySelector(this.element).classList.add('is-sticky');
	}

	closeLoginDropdown(e) {
		if (e.target.closest(this.element)) {
			return;
		}
		
		if (e.target.tagName.toLowerCase() === 'com-1password-button') {
			return;
		}
		
		this.loginBox.classList.remove('is-sticky');
	}
}